import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { AlertService } from '../../../../services/alert.service';
import { NgxPopupComponent } from '../../../shared/ngx-popups/ngx-popups/components/popup.component';
import { EMAIL_PATTERN } from '../../../../utils/constants';
import { AutoUnsubscribe } from '../../../../decorators/auto-unsubscribe';
import { User } from '../../../../models/user';

@Component({
    selector: 'app-user-edit',
    templateUrl: 'edit.component.html',
    styleUrls: ['edit.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class UserEditComponent implements OnInit {
  @Input() popup: NgxPopupComponent; // MANDATORY
  @Input() user: User;

  userForm: FormGroup;
  submitted = false;
  submitAttempt = false;
  subsArr$: Subscription[] = [];

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              private alertService: AlertService,
  ) {

  }

  ngOnInit(): void {
    this.setForm();
  }

  setForm(): void {
    this.userForm = this.formBuilder.group({
      name: [this.user?.name ?? '', [Validators.required]],
      email: [this.user?.email ?? '', [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      admin: this.user?.admin ?? false,
      active: this.user?.active ?? true,
    });
  }

  isFieldInvalid(field: string): boolean {
    return (
      (this.userForm.get(field).invalid && this.userForm.get(field).dirty) ||
      (this.userForm.get(field).invalid && this.submitAttempt)
    );
  }

  save(formValue: any, isValid: boolean) {
    this.submitAttempt = true;
    if (!isValid || this.submitted) {
      return;
    }
    this.submitted = true;

    const payload: User = {
      ...this.user,
      name: formValue.name.trim(),
      email: formValue.email.trim(),
      admin: formValue.admin,
      active: formValue.active,
    } as User;

    this.subsArr$.push(this.userService.updateUser(payload)
      .subscribe(
        data => {
          this.submitted = false;
          this.popup.close(true, true);
          this.alertService.success('User updated successfully');
        },
        error => {
          this.submitted = false;
          this.alertService.error(error.message);
        },
      ));
  }
}
